import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const FileImportIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 15 15" },
        React.createElement("path", { d: "M6.06024 9.59705C6.06024 9.9809 6.46576 10.1773 6.70294 9.90058L8.89105 7.31208C9.03631 7.14027 9.03631 6.85908 8.89105 6.68726L6.70294 4.09876C6.46576 3.82209 6.06024 4.01844 6.06024 4.41114V6.10712H3V0.5C3 0.22382 3.22388 0 3.5 0H14.5C14.7761 0 15 0.22382 15 0.5V8.97998C15 10.0845 14.1046 10.98 13 10.98H11.51C11.2295 10.98 11 11.2095 11 11.49V13C11 14.1046 10.1046 15 9 15H3.5C3.22388 15 3 14.7761 3 14.5V7.89227H6.06024V9.59705ZM0 6.60999V7.39002C0 7.67005 0.21997 7.89002 0.5 7.89002H3V6.10999H0.5C0.21997 6.10999 0 6.33002 0 6.60999Z" })));
};

export { FileImportIcon };
//# sourceMappingURL=FileImportIcon.esm.js.map
